import React from 'react';
import { NavLink } from 'react-router-dom';
import './Layout.css';
import UserMenu from './UserMenu';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      {/* Fixed Header */}
      <header className="App-header">
        <div className="header-content">
          <div className="logo-container">
            <NavLink to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
<svg className="logo-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1013.4 374.7">
                <path fill="#006355" d="M331.3,155.8c9.3,9.2,13.9,21.3,13.9,36.6v82.3h-33.1v-71.6c0-8.8-2.6-15.7-7.7-21.1-5.2-5.2-12-7.8-20.4-7.8s-16.5,2.7-22.1,8.1c-5.6,5.4-8.4,12.6-8.4,21.4v71h-33v-129.4h33v16c10.2-12.8,23.9-19.1,41.1-19.1s27.4,4.6,36.7,13.6h0s0,0,0,0Z"/>
                <path fill="#006355" d="M466.9,100h33v174.6h-33v-17c-10.8,13.4-24.9,20.1-42.1,20.1s-33-6.4-45-19.5c-12.1-13-18.2-29.1-18.2-48.4s6.1-35.3,18.1-48.3c12-12.9,27.1-19.3,45.1-19.3s31.3,6.7,42.1,20.1v-62.3h0ZM456.8,235.5c6.8-6.8,10.2-15.4,10.2-25.5s-3.3-18.7-10.2-25.5c-6.8-6.8-15.4-10.3-25.6-10.3s-18.6,3.5-25.4,10.3c-6.8,6.8-10.2,15.4-10.2,25.5s3.3,18.7,10.2,25.5,15.2,10.3,25.4,10.3,18.8-3.5,25.6-10.3Z"/>
                <path fill="#006355" d="M558.4,164.3c10-14,22.5-21.1,37.8-21.1v34.1c-23.9,0-37.8,13.8-37.8,35.7v61.7h-33v-129.4h33v19h0Z"/>
                <path fill="#006355" d="M612.1,274.6v-129.4h33v129.4h-33Z"/>
                <path fill="#006355" d="M676.4,265.5c-9.3-8-13.9-18-13.9-29.6h33.3c0,4.1,1.5,7.4,4.6,10.3,3,2.9,6.6,4.3,10.9,4.3,8,0,14.4-5.2,14.4-11.6s-7.2-12.5-21.6-16.2c-26.7-6.3-39.9-19.8-39.8-40.6,0-12.4,4.5-22.2,13.5-29.2,8.9-7.1,20-10.5,33-10.5s24.3,3.8,33.2,11.5c8.9,7.7,13.4,17.1,13.4,28.2h-33.2c0-7.1-5.8-12.6-13.6-12.6s-13,4.8-13,10.7,7.5,12.5,22.5,16.2c26,6.6,39,20,39.2,39.9,0,12.9-4.6,23-13.8,30.5-9.3,7.4-20.7,11.2-34.5,11.2s-25.4-4.1-34.7-12.3h0s0,0,0,0Z"/>
                <path fill="#006355" d="M782.5,265.5c-9.3-8-13.9-18-13.9-29.6h33.3c0,4.1,1.5,7.4,4.6,10.3,3,2.9,6.6,4.3,10.9,4.3,8,0,14.4-5.2,14.4-11.6s-7.2-12.5-21.6-16.2c-26.7-6.3-39.9-19.8-39.8-40.6,0-12.4,4.5-22.2,13.5-29.2,8.9-7.1,20-10.5,33-10.5s24.3,3.8,33.2,11.5c8.9,7.7,13.4,17.1,13.4,28.2h-33.2c0-7.1-5.8-12.6-13.6-12.6s-13,4.8-13,10.7,7.5,12.5,22.5,16.2c26,6.6,39,20,39.2,39.9,0,12.9-4.6,23-13.8,30.5-9.3,7.4-20.7,11.2-34.5,11.2s-25.4-4.1-34.7-12.3h0s0,0,0,0Z"/>
                <path fill="#07ff9d" d="M888.4,146.8c-7.1,0-13.1-2.4-17.9-7.2-4.8-4.8-7.1-10.7-7.1-17.8s2.4-13,7.1-17.8c4.8-4.8,10.7-7.2,17.9-7.2s13.1,2.4,17.9,7.2,7.1,10.7,7.1,17.8-2.4,13-7.1,17.8c-4.8,4.8-10.7,7.2-17.9,7.2Z"/>
                <polygon fill="#006355" points="135 203.2 185.8 203.2 186.1 170.3 135 170.3 135 132.9 192.9 132.9 205.9 100 100 100 100 274.7 201.1 274.7 201.1 241.8 135 241.8 135 203.2"/>
              </svg>
            </NavLink>
          </div>
          <div className="title-container">
            <h1>PDF Formular Manager</h1>
            <p>Professionelle PDF-Formular-Automatisierung</p>
          </div>
          <UserMenu />
        </div>
      </header>

      {/* Sidebar Navigation */}
      <aside className="sidebar">
        <nav className="sidebar-nav">
          <NavLink
            to="/projects"
            className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
          >
            <span className="nav-icon">📋</span>
            <span className="nav-label">Projekte</span>
          </NavLink>
          <NavLink
            to="/datasources"
            className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
          >
            <span className="nav-icon">📊</span>
            <span className="nav-label">Datenvorlagen</span>
          </NavLink>
          <NavLink
            to="/formulare"
            className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
          >
            <span className="nav-icon">📄</span>
            <span className="nav-label">Formulare</span>
          </NavLink>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>
    </>
  );
};

export default Layout;
